import { jsx, Fragment } from 'react/jsx-runtime';

var MasonryItem = function (props) {
    var children = props.children;
    return jsx(Fragment, { children: children });
};
var MasonryAbsoluteItem = function (props) {
    var children = props.children;
    return jsx(Fragment, { children: children });
};

export { MasonryAbsoluteItem, MasonryItem };
